import styled, { createGlobalStyle } from 'styled-components'

export const GlobalCloseWebStyled = createGlobalStyle`
  .layout-container-login {
    background-image: unset !important;
    background-color: #FFF !important;
  }
`

export const CloseWebStyled = styled.div`
  min-width: 50%;
  min-height: 300px;
  padding: 0px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;

  img {
    max-width: 100%;
  }

  .text-closeweb {
    font-size: 20px;
    line-height: 1.7;
    color: #000;

    .logo {
      width: 100px;
      margin-bottom: 48px;
    }

    .txt-title {
      font-size: 25px;
      margin-bottom: 12px;
    }

    .txt-bottom {
      margin-top: 15px;
    }

    p {
      margin-bottom: 0.5em;
    }
  }

  @media screen and (max-width: 768px) {
    .text-closeweb {
      margin-top: 50px;
      font-size: 14px;
    }
  }
`
